<template>
	<div class="page-content">
		<div class="container">
			<!-- 第一行 -->
			<div class="card section">
				<div class="row" style="padding:14px">
					<div class="seg" id="tradeMode">
						<button :class="{ active: TranType == 'b2b'}" @click="setPrice('b2b')" data-lang="t_33"></button>
						<button :class="{ active: TranType == 'c2c'}" @click="setPrice('c2c')">C2C</button>
					</div>
					<div class="pill">
						<span data-lang="t_140"></span> 
						<b style="color:var(--text)">{{Price}}</b>
					</div>
				</div>
				<div class="row" >
					<div class="title">
						<span data-lang="t_141"></span>
						<div class="v" style="margin-top:4px;text-align: center;">{{Volume24}}</div>
					</div>
					<div class="title" style="text-align:center">
						<span data-lang="t_142"></span>
						<div class="v" style="margin-top:4px;text-align: center;">{{WaitTransactionVol}}</div>
					</div>
					<!--<button class="btn btn-link" @click="modal_showDataDetails = true">数据详情 &gt;</button>-->
				</div>
				<div class="grid grid-3" style="background-color: rgba(255, 255, 255, 0.1);border-radius: 12px;">
					<div class="item_1" style="text-align: center;">
						<div class="title" data-lang="t_112"></div>
						<div class="v">{{balanceOfUSDT}}</div>
					</div>
					<div class="item_1" style="text-align: center;">
						<div class="title" data-lang="t_113"></div>
						<div class="v">{{balanceOfBNB}}</div>
					</div>
					<div class="item_1" style="text-align: center;">
						<div class="title" data-lang="t_114"></div>
						<div class="v">{{balanceOfATM}}</div>
					</div>
				</div>
			</div>

			<!-- 第五行：很多条目的控件 -->
			<div class="card section">
				<div class="row">
					<button class="btn btn-primary" @click="placeOrderBtnClick()" data-lang="t_143"></button>
					<button class="btn btn-primary" @click="getMyOrderList()" data-lang="t_144"></button>
				</div>

				<div class="row" >
					<div class="h2" data-lang="t_145"></div>
					<button class="btn btn-primary"  @click="details = true" data-lang="t_146"></button>
				</div>
				<div class="list" style="padding:14px">
					<div class="item" v-for="(item, index) in OrderListC2C" :key="index">
						<div class="row">
							<div class="addr">{{item.show_seller}}</div>
							<div class="muted">{{item.show_createTime}}</div>
						</div>
						<div class="row" style="margin-top:8px">
							<div>
								<div class="k" >{{t_147}}</div>
								
								<div class="v">{{item.show_price}}</div>
							</div>
							<div style="text-align:center;">
								<div class="k">{{t_148}}</div>
								<div class="v">{{item.show_balance}} / {{item.show_amount}}</div>
							</div>
							<div style="text-align:right;">
								<button class="btn btn-active" @click="buyList(item.id,item.price,item.show_balance)" >{{t_149}}</button>
							</div>
						</div>
					</div>
				</div>
				<div class="loading" id="tradeLoading" data-lang="t_150"></div>
			</div>
		</div>

		<!-- 数据详情对话框 -->
		<div class="modalMask fullscreen" :class="{show: modal_showDataDetails == true}">
			<div class="modal">
				<div class="modalHead">
					<div data-lang="t_151"></div>
					<div class="modalClose" @click="modal_showDataDetails = false">×</div>
				</div>
				<div class="modalBody">
					<div class="grid grid-2">
						<div class="item">
							<div class="title" data-lang="t_152"></div>
							<div class="v">~</div>
						</div>
						<div class="item">
							<div class="title" data-lang="t_153"></div>
							<div class="v">~</div>
						</div>
						<div class="item">
							<div class="title" data-lang="t_141"></div>
							<div class="v">~</div>
						</div>
						<div class="item">
							<div class="title" data-lang="t_154"></div>
							<div class="v">~</div>
						</div>
					</div>

					<div class="hr"></div>

					<div class="h2" data-lang="t_155"></div>
					<div class="list" style="margin-top:10px"></div>
				</div>
				<div class="modalFoot">
					<button class="btn" @click="modal_showDataDetails = false" data-lang="t_132"></button>
				</div>
			</div>
		</div>

		<!-- 发布订单对话框 -->
		<div class="modalMask" :class="{show: modal_placeOrder == true}">
			<div class="modal">
				<div class="modalHead">
					<div data-lang="t_143"></div>
					<div class="modalClose" @click="modal_placeOrder = false">×</div>
				</div>
				<div class="modalBody">
					<div class="seg" id="publishTabs">

						<button :class="{ active: TranType == 'b2b'}" data-lang="t_156"></button>
						<button :class="{ active: TranType == 'c2c'}" data-lang="t_157"></button>
					</div>

					<div class="item" style="margin-top:10px">
						<div class="row">
							<div class="title" data-lang="t_140"></div>
							<div class="v">{{Price}}</div>
						</div>
						<div class="row" style="margin-top:8px">
							<div class="title" data-lang="t_53"></div>
							<div class="v">{{balanceOfATM}}</div>
						</div>
					</div>

					<div class="field">
						<div class="row">
							<div class="title" style="text-align: left;" data-lang="t_158"></div>
							<input v-model="sell_price_inputBox" :disabled="priceIsDisabled" data-placeh="t_159"/>
							<button class="btn btn-mini" style="margin-left: 0px;">U</button>
						</div>
						
					</div>
					<div class="field">						
						<div class="row">
							<div class="title" style="text-align: left;" data-lang="t_161"></div>
							<input v-model="sell_amount_inputBox" data-placeh="t_160" />
							<button class="btn btn-mini" @click="sell_amount_inputBox = balanceOfATM" data-lang="t_162"></button>
						</div>
					</div>
					<div class="field">
						<div class="title" style="text-align: left;" data-lang="t_163"></div>
						<textarea rows="2" v-model="sell_target_inputBox" placeholder="0x..." ></textarea>
					</div>
				</div>
				<div class="modalFoot">
					<button class="btn" @click="modal_placeOrder = false" data-lang="t_55"></button>
					<button class="btn btn-primary" @click="onPublicSellList()" data-lang="t_164"></button>
				</div>
			</div>
		</div>

		<!-- 我的订单对话框（待完成/已完成 无限加载） -->
		<div class="modalMask fullscreen" :class="{show: modal_myorders == true}">
			<div class="modal">
				<div class="modalHead">
					<div data-lang="t_165"></div>
					<div class="modalClose" @click="modal_myorders = false">×</div>
				</div>
				<div class="modalBody" id="myOrdersBody">
					<div class="seg" id="myOrderTabs">
						<button :class="{active: showMyOrderListAction == 3}" @click="showMyOrderListFunc(3)" data-lang="t_166"></button>
						<button :class="{active: showMyOrderListAction == 2}" @click="showMyOrderListFunc(2)" data-lang="t_167"></button>
						<button :class="{active: showMyOrderListAction == 5}" @click="showMyOrderListFunc(5)" data-lang="t_168"></button>
						<button :class="{active: showMyOrderListAction == 6}" @click="showMyOrderListFunc(6)" data-lang="t_169"></button>
						
					</div>
					<div class="list" style="margin-top:10px">
						<div class="item" v-for="(item, index) in showMyOrderList" :key="index">
							<div class="row">
								<div class="addr">{{item.show_seller}}</div>
								<div class="muted">{{item.show_createTime}}</div>
							</div>
							<div class="row" style="margin-top:8px">
								<div>
									<div class="k" >{{t_147}}</div>
									<div class="v">{{item.show_price}}</div>
								</div>
								<div style="text-align:center;">
									<div class="k" >{{t_170}}</div>
									<div class="v">{{item.show_balance}}</div>
								</div>
								<div style="text-align:right;">
									<button v-if="showMyOrderListAction == 3" class="btn btn-mini" @click="cancelList(item.id)" >{{cancelOrderBtn}}</button>
									<button v-if="showMyOrderListAction == 2" class="btn btn-mini" @click="buyList(item.id,item.price,item.show_balance)" data-lang="t_172">{{buyOrderBtn}}</button>
									<div class="v">{{item.MyOrderType}}</div>
								</div>
							</div>
						</div>
					</div>
					<div class="loading" id="myOrderLoading" data-lang="t_173"></div>
				</div>
				<div class="modalFoot">
					<button class="btn" @click="modal_myorders = false" data-lang="t_132"></button>
				</div>
			</div>
		</div>
		<!-- 流水明细页对话框 -->
		<div class="modalMask fullscreen" :class="{ show: details == true }" id="modal-detail">
			<div class="modal">
				<div class="modalHead">
					<div data-lang="t_146"></div>
					<div class="modalClose" @click="details = false">×</div>
				</div>
				<div class="modalBody" id="detailBody">
		
					<!-- 日期控件 -->
					<div>
						<!--<div class="title">选择日期</div>
						<input id="detailDate" type="date" />-->
						<div class="date-container">
							<div class="date-selector">
								<div class="date-content">
									<div class="date-year-section">
										<div class="date-year-header">
											<span class="date-current-year" @click="onShowYear()">{{selectYear}}
												<span data-lang="t_175"></span></span>
											<span class="date-current-year" @click="onShowMonth()">{{selectMonth}}
												<span data-lang="t_176"></span></span>
										</div>
									</div>
									<div class="date-month-section">
										<div class="date-year-grid" v-if="showSetYear">
											<div class="date-month-item"
												@click="selectYear ='2026';showSetYear = false;">2026</div>
											<div class="date-month-item"
												@click="selectYear ='2027';showSetYear = false;">2027</div>
											<div class="date-month-item"
												@click="selectYear ='2028';showSetYear = false;">2028</div>
											<div class="date-month-item"
												@click="selectYear ='2029';showSetYear = false;">2029</div>
											<div class="date-month-item"
												@click="selectYear ='2030';showSetYear = false;">2030</div>
											<div class="date-month-item"
												@click="selectYear ='2031';showSetYear = false;">2031</div>
											<div class="date-month-item"
												@click="selectYear ='2032';showSetYear = false;">2032</div>
											<div class="date-month-item"
												@click="selectYear ='2033';showSetYear = false;">2033</div>
											<div class="date-month-item"
												@click="selectYear ='2034';showSetYear = false;">2034</div>
											<div class="date-month-item"
												@click="selectYear ='2035';showSetYear = false;">2035</div>
											<div class="date-month-item"
												@click="selectYear ='2036';showSetYear = false;">2036</div>
											<div class="date-month-item"
												@click="selectYear ='2037';showSetYear = false;">2037</div>
											<div class="date-month-item"
												@click="selectYear ='2038';showSetYear = false;">2038</div>
											<div class="date-month-item"
												@click="selectYear ='2039';showSetYear = false;">2039</div>
											<div class="date-month-item"
												@click="selectYear ='2040';showSetYear = false;">2040</div>
											<div class="date-month-item"
												@click="selectYear ='2041';showSetYear = false;">2041</div>
											<div class="date-month-item"
												@click="selectYear ='2042';showSetYear = false;">2042</div>
											<div class="date-month-item"
												@click="selectYear ='2043';showSetYear = false;">2043</div>
											<div class="date-month-item"
												@click="selectYear ='2044';showSetYear = false;">2044</div>
											<div class="date-month-item"
												@click="selectYear ='2045';showSetYear = false;">2045</div>
											<div class="date-month-item"
												@click="selectYear ='2046';showSetYear = false;">2046</div>
											<div class="date-month-item"
												@click="selectYear ='2047';showSetYear = false;">2047</div>
											<div class="date-month-item"
												@click="selectYear ='2048';showSetYear = false;">2048</div>
											<div class="date-month-item"
												@click="selectYear ='2049';showSetYear = false;">2049</div>
											<div class="date-month-item"
												@click="selectYear ='2050';showSetYear = false;">2050</div>
										</div>
										<div class="date-month-grid" v-if="showSetMonth">
											<div class="date-month-item"
												@click="selectMonth ='01';showSetMonth = false;">1</div>
											<div class="date-month-item"
												@click="selectMonth ='02';showSetMonth = false;">2</div>
											<div class="date-month-item"
												@click="selectMonth ='03';showSetMonth = false;">3</div>
											<div class="date-month-item"
												@click="selectMonth ='04';showSetMonth = false;">4</div>
											<div class="date-month-item"
												@click="selectMonth ='05';showSetMonth = false;">5</div>
											<div class="date-month-item"
												@click="selectMonth ='06';showSetMonth = false;">6</div>
											<div class="date-month-item"
												@click="selectMonth ='07';showSetMonth = false;">7</div>
											<div class="date-month-item"
												@click="selectMonth ='08';showSetMonth = false;">8</div>
											<div class="date-month-item"
												@click="selectMonth ='09';showSetMonth = false;">9</div>
											<div class="date-month-item"
												@click="selectMonth ='10';showSetMonth = false;">10</div>
											<div class="date-month-item"
												@click="selectMonth ='11';showSetMonth = false;">11</div>
											<div class="date-month-item"
												@click="selectMonth ='12';showSetMonth = false;">12</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- 8个Tab -->
					<div class="field">
						<!--<div class="title">记录类型</div>
						 1=激活节点 2=领取收益 3=提现 4=股东分红 5=挂卖单 6=撤单 7 = 买入 8=卖出 -->
						<div class="seg" id="detailTabs">
							<button :class="{ active: HistoryType == 0}" @click="setHistoryData(0)" data-lang="t_162"></button>
							<button :class="{ active: HistoryType == 1}" @click="setHistoryData(1)" data-lang="t_3"></button>
							<button :class="{ active: HistoryType == 2}" @click="setHistoryData(2)" data-lang="t_105"></button>
							<button :class="{ active: HistoryType == 3}" @click="setHistoryData(3)" data-lang="t_107"></button>
							<button :class="{ active: HistoryType == 4}" @click="setHistoryData(4)" data-lang="t_177"></button>
							<button :class="{ active: HistoryType == 5}" @click="setHistoryData(5)" data-lang="t_178"></button>
							<button :class="{ active: HistoryType == 6}" @click="setHistoryData(6)" data-lang="t_171"></button>
							<button :class="{ active: HistoryType == 7}" @click="setHistoryData(7)" data-lang="t_172"></button>
							<button :class="{ active: HistoryType == 8}" @click="setHistoryData(8)" data-lang="t_179"></button>
						</div>
					</div>
					<div style="width: 100%;overflow-x: auto;">
						<table class="data-table" id="dataTable">
							<thead>
								<tr>
									<th data-lang="t_180"></th>
									<th data-lang="t_181"></th>
									<th data-lang="t_182"></th>
									<th data-lang="t_183"></th>
									<th data-lang="t_184"></th>
									<th data-lang="t_185"></th>
									<th data-lang="t_184"></th>
									<th data-lang="t_186"></th>
									<th data-lang="t_184"></th>
								</tr>
							</thead>
							<tbody >
								<tr v-for="(item, index) in HistoryData" :key="index">
									<td>{{ item.time }}</td><!--时间-->
									<td>{{item.action}}</td> <!--动作-->
									<td>{{item.to}}</td><!--对方ID-->
									<td :style="{ color: item.ATMChange=='~'?'#2EC9FF': item.ATMChange >0 ? '#F00':'#0F0'}">{{item.ATMChange}}</td><!--钱包余额变化-->
									<td>{{item.ATMAfter }}</td><!--变化后余额-->
									<td :style="{ color: item.insideATMChange=='~'?'#2EC9FF': item.insideATMChange >0 ? '#F00':'#0F0'}">{{item.insideATMChange }}</td><!--账户余额变化-->
									<td>{{item.insideATMAfter}}</td><!--变化后余额-->
									<td :style="{ color: item.usdtChange=='~'?'#2EC9FF': item.usdtChange >0 ? '#F00':'#0F0'}">{{item.usdtChange }}</td><!--usdt余额变化-->
									<td>{{item.usdtAfter }}</td><!--变化后余额-->
									
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Transaction',
		data() {
			return {
				minPrice: 0,
				maxPrice: 0,
				B2BPrice: 0,
				Price: 0,
				Volume24: 0, //24小时成效量
				WaitTransactionVol: 0, //当前待交易量
				balanceOfATM:0,//钱包余额
				balanceOfUSDT:0,
				balanceOfBNB:0,
				
				TranType: "b2b",
				modal_showDataDetails: false, //显示数据详情
				modal_placeOrder: false, //显示发布订单对话框
				modal_myorders: false, //显示我的订单
				OrderListC2C: [], //c2c订单列表
				SellOrderListWait:[],//待卖
				buyOrderListWait:[],//待买
				SellOrderListAlready:[],//已卖
				buyOrderListAlready:[],//已买
				showMyOrderList:[],//显示我的订单
				showMyOrderListAction:1,//3表示显示我的待卖，2表示我的待买，5表示我的已卖，6表示我的已买
				
				sell_price_inputBox:"",//卖币价格输入框
				sell_amount_inputBox:"",//卖币数量输入框
				sell_target_inputBox:"",//卖币目标地址输入框
				priceIsDisabled:false,//是否禁用卖币价格输入框
				UserType:0,//用户类型
				
				UserId: 0, //
				details: false, //流水明细
				HistoryType: 0,
				HistoryData: [], //历史记录
				HistoryDataAll: [], //历史记录
				showSetYear: false, //显示日期选择组件
				showSetMonth: false, //显示月份选择组件
				selectYear: 2025,
				selectMonth: "01",
				cancelOrderBtn:Lang[lg].t_171,
				buyOrderBtn:Lang[lg].t_172,
				t_147:Lang[lg].t_147,
				t_148:Lang[lg].t_148,
				t_149:Lang[lg].t_149,
				t_170:Lang[lg].t_170,
				
			}
		},
		mounted() {
			this.setLanguage();
			this.showUI();
			
			let d = new Date();
			this.selectYear = d.getFullYear();
			this.selectMonth = d.getMonth() + 1;
			this.selectMonth = this.selectMonth.toString().padStart(2, "0");
		},
		methods: {
			setLanguage(){
				let elements = document.querySelectorAll('[data-lang]');
				elements.forEach(element => {
				    const langValue = element.getAttribute('data-lang');
				    element.innerHTML = Lang[lg][langValue];
				});
				elements = document.querySelectorAll('[data-placeh]');
				elements.forEach(element => {
				    const langValue = element.getAttribute('data-placeh');
				    element.placeholder = Lang[lg][langValue];
				});
			},
			async placeOrderBtnClick(){
				this.modal_placeOrder = true;
				
				if(this.UserType == 0){
					const user = await conExc.getUser(Account).call();
					this.UserType = user.Type;
				}
				
				
				if(this.UserType == 1 || this.UserType == 3 || this.UserType == 11)this.setPrice("c2c");
				else{
					this.setPrice("b2b");
				}
			},
			setPrice(trantype) {
				if (trantype == "b2b") {
					this.Price = this.B2BPrice;
					this.priceIsDisabled = true;
					this.sell_price_inputBox = this.B2BPrice;
				}
				else {
					this.Price = this.minPrice + "~" + this.maxPrice;
					this.priceIsDisabled = false;
					this.sell_price_inputBox = this.minPrice;
				}
				this.TranType = trantype;
			},
			readOderList(data) {
				const len = data.length;
				let point = 2;
				let list = [];
				let index = 0;
				while (len - point > 10) {
					list[index] = {};
					list[index]["seller"] = "0x" + data.substring(point, point + 40);
					list[index]["show_seller"] = list[index]["seller"].substring(0,6)+"..." + list[index]["seller"].substring(38,42)
					point = point + 40;
					list[index]["price"] = Number("0x" + data.substring(point, point + 8));
					list[index]["show_price"] = list[index]["price"] / 100;
					point = point + 8;
					list[index]["amount"] = Number("0x" + data.substring(point, point + 8));
					list[index]["show_amount"] = list[index]["amount"] / 100;
					point = point + 8;
					list[index]["status"] = Number("0x" + data.substring(point, point + 2));
					point = point + 2;
					list[index]["buyer"] = "0x" + data.substring(point, point + 40);
					point = point + 40;
					list[index]["createTime"] = Number("0x" + data.substring(point, point + 8));
					list[index]["show_createTime"]=new Date(list[index]["createTime"] *1000).toLocaleString();
					point = point + 8;
					list[index]["id"] = Number("0x" + data.substring(point, point + 8));
					point = point + 8;
					list[index]["balance"] = Number("0x" + data.substring(point, point + 6));
					list[index]["show_balance"] = list[index]["balance"] /100;
					point = point + 6;
					if(list[index]["status"] == 1)list[index].MyOrderType = "";
					else if(list[index]["status"] == 2)list[index].MyOrderType = Lang[lg].t_187;
					else if(list[index]["status"] == 3)list[index].MyOrderType = Lang[lg].t_188;
					index++;
				}
				console.log(list)
				return list;
			},
			async showUI() {
				
				const sysInfo = await conExc.getExchange().call();
				
				this.minPrice = Number(sysInfo.minPrice) / 100 ;
				this.maxPrice = Number(sysInfo.maxPrice) / 100 ;
				this.B2BPrice = Number(sysInfo.b2bPrice) / 100 ;
				this.setPrice(this.TranType);

				this.WaitTransactionVol = Number(sysInfo.PendingTrading) / 100;
				await Sleep(this.$waitTime);
				const currentTime = await conHis.getTime().call();
				let day = Math.floor(currentTime / 86400)
				const vol = await conExc.get_dailyVolume(day).call();
				this.Volume24 = Number(vol) / 100; //
				//获取c2c订单
				await Sleep(this.$waitTime);
				const exc = await conExc.getExchange().call();
				console.log("exc.firstPending="+exc.firstPending)
				if(exc.firstPending > 0){
					await Sleep(this.$waitTime);
					let data = await conExc.getListBatch(1, exc.firstPending, 100).call();
					this.OrderListC2C = this.readOderList(data);
					
				}
				await Sleep(this.$waitTime);
				const ATM = await conATM.balanceOf(Account).call();
				this.balanceOfATM = Number(ATM)/100;
				await Sleep(this.$waitTime);
				const usdt = await conUSDT.balanceOf(Account).call();
				this.balanceOfUSDT = Math.floor(web3.utils.fromWei(usdt)*100)/100;
				await Sleep(this.$waitTime);
				const bnb = await web3.eth.getBalance(Account);
				this.balanceOfBNB = Math.floor(web3.utils.fromWei(bnb) * 10000)/10000;
			},
			async getMyOrderList(){
				this.modal_myorders = true;
				
				const user = await conExc.getUser(Account).call();
				this.UserType = user.Type;
				let data;
				this.SellOrderListWait =[];
				this.buyOrderListWait=[];
				this.SellOrderListAlready=[];
				this.buyOrderListAlready=[];
				if(user.sellerPendingFirst > 0){
					data = await conExc.getListBatch(3,user.sellerPendingFirst,100).call();//我的待卖
					this.SellOrderListWait = this.readOderList(data);
				}
				if(user.buyerPendingFirst > 0){
					data = await conExc.getListBatch(2,user.buyerPendingFirst,100).call();//我的待买
					this.buyOrderListWait = this.readOderList(data);
				}
				if(user.sellerCompleteFirst > 0){
					data = await conExc.getListBatch(5,user.sellerCompleteFirst,100).call();//我的已卖
					this.SellOrderListAlready = this.readOderList(data);
				}
				if(user.buyerCompleteFirst){
					data = await conExc.getListBatch(6,user.buyerCompleteFirst,100).call();//我的已买
					this.buyOrderListAlready = this.readOderList(data);
				}
				//showMyOrderListAction:1,//3表示显示我的待卖，2表示我的待买，5表示我的已卖，6表示我的已买
				
				if(this.showMyOrderListAction == 3)this.showMyOrderList = this.SellOrderListWait;
				else if(this.showMyOrderListAction == 2)this.showMyOrderList = this.buyOrderListWait;
				else if(this.showMyOrderListAction == 5)this.showMyOrderList = this.SellOrderListAlready;
				else if(this.showMyOrderListAction == 6)this.showMyOrderList = this.buyOrderListAlready;
				
			},
			showMyOrderListFunc(action){
				this.showMyOrderListAction = action;
				if(action == 3)this.showMyOrderList = this.SellOrderListWait;
				else if(action == 2)this.showMyOrderList = this.buyOrderListWait;
				else if(action == 5)this.showMyOrderList = this.SellOrderListAlready;
				else if(action == 6)this.showMyOrderList = this.buyOrderListAlready;
				
			},
			getHistoryData(his){
				let hisData = [];
				try{
					const len = his.length;
					let point = 2;
					let index = 0;
					while (point < len) {
						let data = {};
						data["ATMChange"] = Number("0x" + his.substring(point, point + 6))/100;
						point += 6;
						data["ATMAfter"] = Number("0x" + his.substring(point, point + 8))/100;
						point += 8;
						if(data["ATMChange"] == 0) {
							data["ATMAfter"] = "~";
						}
						data["insideATMChange"] = Number("0x" + his.substring(point, point + 6))/100;
						point += 6;
						data["insideATMAfter"] = Number("0x" + his.substring(point, point + 8))/100;
						point += 8;
						if(data["insideATMChange"] == 0){
							data["insideATMChange"] = "~";
							data["insideATMAfter"] = "~";
						}
						data["usdtChange"] = Number("0x" + his.substring(point, point + 6))/100;
						point += 6;
						data["usdtAfter"] = Number("0x" + his.substring(point, point + 8))/100;
						point += 8;
						if(data["usdtChange"] == 0){
							data["usdtChange"] = "~";
							data["usdtAfter"] = "~";
						}
						data["time"] = Number("0x" + his.substring(point, point + 8));
						point += 8;
						data["timestamp"] = data["time"];
						data["time"] = new Date(data["time"] * 1000).toLocaleString();
						data["from"] =  his.substring(point, point + 6);
						
						point += 6;
						data["to"] =his.substring(point, point + 6);
						data["to"] = data["to"].toLocaleUpperCase();
						point += 6;
						data["type"] = Number("0x" + his.substring(point, point + 2));
						point += 2;
						
						if(data["to"] == "000000")data["to"] = "~";
						if (data["type"] == 1) {
							data["action"] = Lang[lg].t_88;
							if(data["ATMChange"] >0)data["ATMChange"] = "-" + data["ATMChange"];
							if(data["insideATMChange"] >0)data["insideATMChange"] = "-" + data["insideATMChange"]
						}
						else if (data["type"] == 2) {
							data["action"] = Lang[lg].t_189;
							data["insideATMChange"] = "+" + data["insideATMChange"]
						}
						else if (data["type"] == 3) {
							data["action"] = Lang[lg].t_190;
							data["ATMChange"] = "+" + data["ATMChange"];
							data["insideATMChange"] = "-" + data["insideATMChange"]
						}
						else if (data["type"] == 4) {
							data["action"] = Lang[lg].t_191;
							data["ATMChange"] = "+" + data["ATMChange"];
						}
						else if (data["type"] == 5) {
							data["action"] = Lang[lg].t_192;
							data["ATMChange"] = "-" + data["ATMChange"];
						}
						else if (data["type"] == 6) {
							data["action"] = Lang[lg].t_171;
							data["ATMChange"] = "+" + data["ATMChange"];
						}
						else if (data["type"] == 7) {
							data["action"] = Lang[lg].t_193;
							if(data["ATMChange"] > 0)data["ATMChange"] = "+" + data["ATMChange"];
							if(data["insideATMChange"] >0)data["insideATMChange"] = "+" + data["insideATMChange"];
							data["usdtChange"]  = "-" + data["usdtChange"];
						}
						else if (data["type"] == 8) {
							data["action"] = Lang[lg].t_194;
							data["usdtChange"]  = "+" + data["usdtChange"];
						}
						hisData[index] = data;
						index++;
					}
				}catch(e){
					
				}
				
				return hisData;
			},
			
			async setHistoryAll(){
				this.HistoryType = 0;
				let year = Number(this.selectYear);
				let month = Number(this.selectMonth);
				
				this.HistoryDataAll = [];
				this.UserId = await conMine.getFindIdFromAddress(Account).call();
				let his = await conHis.getHistory(this.UserId, year, month, 100).call();
				
				this.HistoryDataAll = this.getHistoryData(his);
			},
			async setHistoryData(type) {
				
				if(this.HistoryDataAll.length === 0) await this.setHistoryAll();
				this.HistoryData = [];
				let hisData=[];
				this.HistoryDataAll.forEach(item =>{
					if(type == 0)hisData.push(item)
					else if(type == item.type)hisData.push(item);
				});
				this.HistoryData = hisData;
				this.HistoryType = type;
			},
			
			async onPublicSellList(){
				
				if (this.TranType == "b2b" && this.sell_target_inputBox.length != 42){
					MsgBox.open(Lang[lg].t_143,Lang[lg].t_195);
					return;
				}
				if(this.sell_target_inputBox.length == 0)this.sell_target_inputBox ="0x0000000000000000000000000000000000000000";
				if (!web3.utils.isAddress(this.sell_target_inputBox)){
					MsgBox.open(Lang[lg].t_143,Lang[lg].t_196+this.sell_target_inputBox+Lang[lg].t_197);
					this.sell_target_inputBox = "";
					return;
				}
				
				if(this.sell_amount_inputBox < 1) {
					MsgBox.open(Lang[lg].t_143,Lang[lg].t_198);
					return;
				}
				if(this.TranType == "c2c"){
					const Warning_dialog = document.getElementById("modal-msgbox");					
					const Warning_cancel = document.getElementById("msgbox-cancel");
					const Warning_close = document.getElementById("msgbox-close");
					const Warning_confirm = document.getElementById("msgbox-ok");
					const Warning_Info = document.getElementById("msgbox-caption");
					
					Warning_dialog.classList.add("show");
					const totalPrice = Number(this.sell_price_inputBox) * Number(this.sell_amount_inputBox);
					Warning_Info.textContent = Lang[lg].t_199 + totalPrice +"U ；" + Lang[lg].t_200 + Math.round(totalPrice* 10)/100+
							" U，"+ Lang[lg].t_201 + Math.round(totalPrice * 90)/100 +" U";
					const okb = await new Promise((resolve) => {
							// 事件监听
							Warning_cancel.onclick = () => {
								Warning_dialog.classList.remove("show");
								resolve(false);
							};
							Warning_close.onclick = () => {
								Warning_dialog.classList.remove("show");
								resolve(false);
							};
							Warning_confirm.onclick = () => {
								Warning_dialog.classList.remove("show");
								resolve(true);
							};
						});
					if(okb == false)return;
				}
				
				try{
					//先授权
					if(await gasIsEnough() == false)return;
					let allowance = await conATM.allowance(Account,addrExc).call();
					const amount = Math.ceil(this.sell_amount_inputBox * 100).toString();
					
					if(Number(allowance) < amount){//授权
						
						MsgBox.waitTX(Lang[lg].t_12,Lang[lg].t_202);
						let par = {
							from:Account,
							to:addrATM, 
							gasPrice:await web3.eth.getGasPrice(), 
							nonce:await web3.eth.getTransactionCount(Account)
						};
						const gas = await conATM.approve(addrExc,amount).estimateGas(par);
						par.gas = gas;
						await  conATM.approve(addrExc,amount).send(par);
					}
					
					//this.sell_price_inputBox:"",//卖币价格输入框
					//this.sell_amount_inputBox:"",//卖币数量输入框
					MsgBox.waitTX(Lang[lg].t_143,Lang[lg].t_143);
					let par = {
						from:Account,
						to:addrExc, 
						gasPrice:await web3.eth.getGasPrice(), 
						nonce:await web3.eth.getTransactionCount(Account)
					};
					//sell(uint32 amount,uint32 price,address to,bool isC2C)
					
					const price =Math.round(this.sell_price_inputBox * 100).toString();
					const isC2C = this.TranType == "b2b"?false:true;
					const gas = await conExc.sell(amount,price,this.sell_target_inputBox,isC2C).estimateGas(par);
			
					par.gas = gas;
					const success = await  conExc.sell(amount,price,this.sell_target_inputBox,isC2C).send(par);
					MsgBox.open(Lang[lg].t_143,Lang[lg].t_203);
					this.showUI();
					this.modal_placeOrder = false;
					
				}catch(e){
					MsgBox.open(Lang[lg].t_143,e);
				}

				this.sell_amount_inputBox="";	
				this.sell_target_inputBox="";
				this.sell_price_inputBox="";
			},
			//购买代币
			async buyList(id,price,balance){
				
				try{
					//检查自己的usdt够不够
					if(await gasIsEnough() == false)return;
					//弹出对话框选择输入金额
					//调对话诞框
					const Warning_dialog = document.getElementById("modal-msgbox");
					const Warning_cancel = document.getElementById("msgbox-cancel");
					const Warning_close = document.getElementById("msgbox-close");
					const Warning_confirm = document.getElementById("msgbox-ok");
					const Warning_Info = document.getElementById("msgbox-caption");
					
					Warning_dialog.classList.add("show");
					
					Warning_Info.innerHTML = `
						<p>id:<span>${id}</span></p>
						<div class="row">
							
							<input type="number" id="buyATMCountInput" placeholder="${Lang[lg].t_204}" value ="${balance}"/>
						</div>
					`;
					const Input_Amount = await new Promise((resolve) => {
							// 事件监听
							Warning_cancel.onclick = () => {
								Warning_dialog.classList.remove("show");
								resolve(false);
							};
							Warning_close.onclick = () => {
								Warning_dialog.classList.remove("show");
								resolve(false);
							};
							Warning_confirm.onclick = () => {
								Warning_dialog.classList.remove("show");
								let count = document.getElementById("buyATMCountInput").value;
								resolve(count);
							};
						});
					if(Input_Amount == false)return;
					if(Number(Input_Amount)  >balance){
						MsgBox.open(Lang[lg].t_8,Lang[lg].t_205+ Number(balance) + " ATM");
						return;
					}
					if(Number(Input_Amount) < 1){
						MsgBox.open(Lang[lg].t_8,Lang[lg].t_206);
						return;
					}
					const balanceOf = await conUSDT.balanceOf(Account).call();
					let usdt = Math.ceil(Input_Amount * price )/100;
				
					if(Number(usdt) > Number(web3.utils.fromWei(balanceOf))){
						MsgBox.open(Lang[lg].t_207,Lang[lg].t_208+(usdt) +"usdt");
						return;
					}
					
					//先授权
					let allowance = await conUSDT.allowance(Account,addrExc).call();	
					
					usdt = web3.utils.toWei(usdt.toString());
					if(Number(web3.utils.fromWei(allowance)) < Number(web3.utils.fromWei(usdt.toString()))){//授权
						MsgBox.waitTX(Lang[lg].t_12,Lang[lg].t_209);
						let par = {
							from:Account,
							to:addrUSDT, 
							gasPrice:await web3.eth.getGasPrice(), 
							nonce:await web3.eth.getTransactionCount(Account)
						};
						const gas = await conUSDT.approve(addrExc,usdt).estimateGas(par);
						par.gas = gas;
						await conUSDT.approve(addrExc,usdt).send(par);
					}
					MsgBox.waitTX(Lang[lg].t_207,Lang[lg].t_207);
					let par = {
						from:Account,
						to:addrExc, 
						gasPrice:await web3.eth.getGasPrice(), 
						nonce:await web3.eth.getTransactionCount(Account)
					};
					const amount =Math.round(Number(Input_Amount) * 100) ;
					const gas = await conExc.buy(id,amount).estimateGas(par);
					par.gas = gas;
					const success = await  conExc.buy(id,amount).send(par);
					MsgBox.open(Lang[lg].t_207,Lang[lg].t_210);
					this.modal_myorders = false;
					this.showUI();
					
				}catch(e){
					MsgBox.open(Lang[lg].t_207,e.message);
				}
			},
			async cancelList(id){
				try{
					if(await gasIsEnough() == false)return;
					MsgBox.waitTX(Lang[lg].t_171,Lang[lg].t_171);
					let par = {
						from:Account,
						to:addrExc, 
						gasPrice:await web3.eth.getGasPrice(), 
						nonce:await web3.eth.getTransactionCount(Account)
					};
					const gas = await conExc.CancelOrder(id).estimateGas(par);
					par.gas = gas;
					const success = await conExc.CancelOrder(id).send(par);
					MsgBox.open(Lang[lg].t_171,Lang[lg].t_211);
					this.showUI();
				}catch(e){
					MsgBox.open(Lang[lg].t_171,e.message)
				}
			},
			onShowYear() {
				this.showSetYear = !this.showSetYear;
				this.showSetMonth = false;
			},
			onShowMonth() {
				this.showSetMonth = !this.showSetMonth;
				this.showSetYear = false;
			},
		},		
	}
</script>

